import { User } from "../../user";

// コメント
export class ReceptionComment {
  public id: number;
  public archiveId?: number; // 登録競合チェックで使用
  public type: string;
  public content: string;
  public deleted: boolean;
  public createDateTime: Date;
  public createUser: User;
  public isEditable: boolean;
  public isDeletable: boolean;
  public updateDateTime: Date;

  clone(): ReceptionComment {
    const newObj = new ReceptionComment();
    newObj.id = this.id;
    newObj.archiveId = this.archiveId;
    newObj.type = this.type;
    newObj.content = this.content;
    newObj.deleted = this.deleted;
    newObj.createDateTime = this.createDateTime;
    newObj.createUser = this.createUser;
    newObj.isEditable = this.isEditable;
    newObj.isDeletable = this.isDeletable;
    newObj.updateDateTime = this.updateDateTime;

    return newObj;
  }
}
